class WorkAsset {
  title = '';
  
  docId = '';

  assetId = 0;

  thumbnailUrl = '';

  previewUrl = '';

  constructor(workAsset) {
    if (workAsset != null) {
      this.title = workAsset.title;
      this.docId = workAsset.docId;
      this.assetId = workAsset.assetId;
      this.thumbnailUrl = workAsset.thumbnailUrl;
      this.previewUrl = workAsset.previewUrl;
    }
  }

  static fromObject(data) {
    if (data == null) {
      return null;
    }
    return new WorkAsset(data);
  }

  static fromObjectList(list) {
    if (list == null) {
      return null;
    }

    return list.map((data) => WorkAsset.fromObject(data));
  }
}

export default WorkAsset;
